import React, { FC, ReactElement } from 'react';

import getClassName from 'src/common/utils/getClassName';
import s from './ListingsDropdownItem.module.scss';

type Props = {
  control: ReactElement;
  classNameModifier?: string;
};

const ListingsDropdownItem: FC<Props> = ({
  children,
  control,
  classNameModifier = '',
}) => (
  <li className={getClassName(s, 'root', classNameModifier)}>
    <label className={getClassName(s, 'label', classNameModifier)}>
      {control}
      {children}
    </label>
  </li>
);

export default ListingsDropdownItem;
